import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { Trash2 } from "lucide-react";
import { ClipLoader } from "react-spinners";

export default function DeleteQuestion({ questionId, questionText, onDeleted, triggerButtonProps = {} }) {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { getToken } = useAuth()

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            if (!token) return
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }
            await axios.delete(api_endpoint + `/quiz/question/${questionId}`, reqConfig)
            toast.success("Question deleted successfully")
            setOpen(false)
            if (onDeleted) onDeleted(questionId)
        } catch (error) {
            toast.error("Failed to delete question")
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className="w-4 h-4 text-(--neutral-500) hover:text-blue"
                    {...triggerButtonProps}
                >
                    {/* You can use an icon here if you want */}
                    <Trash2 />
                </Button>
            </DialogTrigger>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="font-heading">Delete Question</DialogTitle>
                </DialogHeader>
                <div className="font-body">
                    Are you sure you want to delete <span className="font-bold">{questionText}</span>? This action cannot be undone.
                </div>
                <div className="mt-4 flex gap-2 justify-between">
                    <DialogClose asChild>
                        <Button variant="outline" onClick={() => setOpen(false)} disabled={loading} className="">
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button
                        variant=""
                        onClick={handleDelete}
                        disabled={loading}
                        className=""
                    >
                        {loading ? (
                                <span className="flex items-center justify-center w-full">
                                    <ClipLoader size={20} color="#fff" />
                                </span>
                            ) : (
                                "Delete"
                            )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}